import { IToolboxComponentGroup } from "@shesha-io/reactjs";
/* NEW_COMPONENT_IMPORT_GOES_HERE */

import MapToolBox from "./mapping";

export const formDesignerComponents: IToolboxComponentGroup[] = [
  {
    name: "Agri ERP",
    components: [MapToolBox],
    visible: true,
  },
];
